export default __webpack_public_path__ + "media/styles/images/owi-grey-3c24c963fc6160254f87b9af0957bba9.png";